import qs            from 'qs';

export const baseHeaders = function(){
  return new Headers({
    'accept': 'application/json, text/javascript */*; q=0.01',
    'accept-encoding': 'gzip, deflate, br',
    'content-type': 'application/x-www-form-urlencoded; charset=UTF-8',
    'x-requested-with': 'XMLHttpRequest',
    'X-CSRF-Token': getHeadCSRFToken()
  });
};
export const getHeadCSRFToken = function(){
  let element = document.querySelector('meta[name="csrf-token"]');
  if(element){
    return element.getAttribute("content");
  }else {
    return ''
  }
}
export const multipartHeaders = function(){
  return new Headers({
    'accept': '*/*',
    'accept-encoding': 'gzip, deflate, br',
  });
}

export const api = {
  validUniqueEmail(params){
    let headers = baseHeaders();
    headers.set('X-CSRF-Token', params.at);
    let fetchParams = {
      method: 'POST',
      body: qs.stringify({ email: params.email, user_id: params.user_id }),
      headers: headers,
      credentials: 'same-origin'
    };
    return fetch('/validators/unique_email', <any>fetchParams)
    .then(response => response.json())
    .then(data => ({ data }))
    .catch(error => ({ error }));
  },

  validUniqueJobno(params){
    let headers = baseHeaders();
    headers.set('X-CSRF-Token', params.at);
    let fetchParams = {
      method: 'POST',
      body: qs.stringify({ job_no: params.job_no, exception: params.exception }),
      headers: headers,
      credentials: 'same-origin'
    };
    return fetch('/validators/unique_jobno', <any>fetchParams)
    .then(response => response.json())
    .then(data => ({ data }))
    .catch(error => ({ error }));
  },

  // getImages(params){
  //   let headers = baseHeaders();
  //   let fetchParams = {
  //     method: 'GET',
  //     headers: headers,
  //     credentials: 'same-origin'
  //   };
  //   return fetch(params.path, <any>fetchParams)
  //   .then(response => response.json())
  //   .then(data => ({ data }))
  //   .catch(error => ({ error }))
  // },

  save(payload){
    let headers = baseHeaders();
    api.setAuthenticityToken(headers, payload)
    let fetchParams = {
      method: payload.method.toUpperCase(),
      body: qs.stringify(payload.params, { arrayFormat: 'brackets' }),
      headers: headers,
      credentials: 'same-origin'
    };
    return fetch(payload.url, <any>fetchParams)
    .then(response => response.json())
    .then(data => ({ data }))
    .catch(error => ({ error }));
  },

  destroy(payload){
    let headers = baseHeaders();
    api.setAuthenticityToken(headers, payload)
    let fetchParams = {
      method: 'DELETE',
      headers: headers,
      credentials: 'same-origin'
    };
    if (payload.params) {
      fetchParams['body'] = qs.stringify(payload.params, { arrayFormat: 'brackets' })
    }
    return fetch(payload.url, <any>fetchParams)
    .then(response => response.json())
    .then(data => ({ data }))
    .catch(error => ({ error }));
  },

  get(payload){
    let query = qs.stringify(payload.params, { arrayFormat: 'brackets' });
    let headers = baseHeaders();
    let fetchParams = {
      method: 'GET',
      headers: headers,
      credentials: 'same-origin'
    };
    return fetch(payload.url + '?' + query, <any>fetchParams)
    .then(response => response.json())
    .then(data => ({ data }))
    .catch(error => ({ error }));
  },

  patch(payload){
    let headers = baseHeaders();
    headers.set('X-CSRF-Token', payload.at);
    let fetchParams = {
      method: 'PATCH',
      body: qs.stringify(payload.params, { arrayFormat: 'brackets' }),
      headers: headers,
      credentials: 'same-origin'
    };
    return fetch(payload.url, <any>fetchParams)
    .then(response => response.json())
    .then(data => ({ data }))
    .catch(error => ({ error }));
  },

  // uploadImage(payload){
  //   let headers = multipartHeaders();
  //   headers.set('X-CSRF-Token', payload.at);
  //   let formData:FormData = new FormData();
  //   formData.append("file", payload.file);
  //   let fetchParams = {
  //     method:      'POST',
  //     headers:     headers,
  //     body:        formData,
  //     credentials: 'same-origin'
  //   };
  //   return fetch(payload.url, <any>fetchParams)
  //   .then(response => response.json())
  //   .then(data => ({ data }))
  //   .catch(error => ({ error }));
  // },
  //
  // destroyImage(payload){
  //   let headers = baseHeaders();
  //   headers.set('X-CSRF-Token', payload.at);
  //   let fetchParams = {
  //     method:      'DELETE',
  //     headers:     headers,
  //     body:        qs.stringify(payload.params),
  //     credentials: 'same-origin'
  //   };
  //   return fetch(payload.url, <any>fetchParams)
  //   .then(response => response.json())
  //   .then(data => ({ data }))
  //   .catch(error => ({ error }));
  // },
  //
  typeahead(payload){
    let headers = baseHeaders();
    let fetchParams = {
      method: 'GET',
      headers: headers,
      credentials: 'same-origin'
    };
    let query = qs.stringify(payload.params, { arrayFormat: 'brackets' });
    return fetch(payload.path + '?' + query, <any>fetchParams)
    .then(response => response.json())
    .then(data => ({ data }))
    .catch(error => ({ error }))
  },
  //
  // getEventTimes(payload){
  //   let headers = baseHeaders();
  //   let fetchParams = {
  //     method: 'GET',
  //     headers: headers,
  //     credentials: 'same-origin'
  //   };
  //   return fetch(payload.path, <any>fetchParams)
  //   .then(response => response.json())
  //   .then(data => ({ data }))
  //   .catch(error => ({ error }))
  // },
  //
  // getTwitterFeed(payload){
  //   let headers = baseHeaders();
  //   let fetchParams = {
  //     method: 'GET',
  //     headers: headers,
  //     credentials: 'same-origin'
  //   };
  //   return fetch(payload.path, <any>fetchParams)
  //   .then(response => response.json())
  //   .then(data => ({ data }))
  //   .catch(error => ({ error }))
  // }
  setAuthenticityToken(headers, payload){
    let authenticity_token = payload.at
    if(!authenticity_token) authenticity_token = App.authenticity_token()
    headers.set('X-CSRF-Token', authenticity_token);
  }
}
